const locale = {
  placeholder: 'Roghnaigh am',
  rangePlaceholder: ['Am tosaigh', 'Am deiridh']
};
export default locale;